import ApplicationController from "./application_controller"
import confetti from "canvas-confetti"
import { prefersReducedMotion } from "../helpers"

export default class extends ApplicationController {
  fire () {
    this.#confetti({
      particleCount: 150,
      spread: 70,
      origin: { y: 1.3 }
    })
  }

  fireFromElement (event) {
    const element = event.submitter || event.target // For submit events form, fire from the submitter
    const offset = element.getBoundingClientRect()

    this.#confetti({
      particleCount: 40,
      startVelocity: 20,
      spread: 180,
      ticks: 40,
      origin: {
        x: (offset.left + (offset.width / 2)) / window.innerWidth,
        y: (offset.top + (offset.height / 2)) / window.innerHeight,
      },
      ...this.#optionsForEmoji(event.params.emoji)
    })
  }

  #optionsForEmoji (emojis) {
    if (!emojis) return;

    return {
      shapes: ([...emojis]).map(emoji => confetti.shapeFromText({ text: emoji, scalar: 1.5 })),
      flat: true,
    }
  }

  #confetti = (options) => {
    if (prefersReducedMotion()) return

    return confetti(options)
  }
}
